const state = {
  companyUserScale: [
    { label: "小于 10 人", value: "RYGM_10" },
    { label: "10 至 50 人 ", value: "RYGM_1050" },
    { label: "50 至 100 人 ", value: "RYGM_50100" },
    { label: "100 至 500 人", value: "RYGM_100500" },
    { label: "500 至 1000 人", value: "RYGM_5001000" },
    { label: "1000 至 2000 人", value: "RYGM_10002000" },
    { label: "2000 人含以上", value: "RYGM_2000" },
  ],

  payState: ["未支付", "已支付"],
  auditStatus: ["待审核", "审核通过", "审核未通过"],
  sendStatus: ["未推送", "推送成功", "推送失败", "定时推送"],
  invoiceStatus: ["未开票", "已开票", "已申请"],
  payMode: ["", "微信"],
  payType: ["", "线上", "线下"],
  invoiceType: ["", "纸质专票", "纸质普票", "电子普票"],
  invoiceTypeM: ["", "线下", "线下", "线上"],
  applicationValidityType: {
    0: "天",
    1: "周",
    2: "月",
    3: "年",
  },
  validityType: ["年", "个月", "周"],

  // 商品类型
  productType: {
    0: "单品",
    1: "商品包",
  },
  // 订单状态
  orderState: [
    "",
    "已保存",
    "待审核",
    "审核未通过",
    "待推送",
    "待支付",
    "审核中",
    "已完成",
    "已取消",
  ],
  // 企业规模
  companyUserScaleShow: {
    RYGM_10: "小于 10 人",
    RYGM_1050: "10 至 50 人",
    RYGM_50100: "50 至 100 人",
    RYGM_100500: "100 至 500 人",
    RYGM_5001000: "500 至 1000 人",
    RYGM_10002000: "1000 至 2000 人",
    RYGM_2000: "2000 人含以上",
  },
  // 企业类型
  companyType: {
    GSLX_QY: "企业",
    GSLX_JG: "机构",
  },
  // 订单来源
  sourceMode: {
    0: "线下",
    1: "线上",
  },
  // 抬头类型
  invoiceTitleType: ["", "单位", "个人"],
  // 发票内容
  invoiceContent: {
    1: "商品明细",
    2: "商品类别",
  },
  // 审核驳回原因
  reason: {
    1: "实付金额与订单总金额不符",
    2: "款项未到账",
    3: "其他原因",
  },
  // 根据渠道类型判断订单来源
  sourceType: {
    0: "线下",
    1: "线下",
    2: "线上",
  },
};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
